module.exports = __webpack_public_path__ + "MaterialIcons-Regular.e79bfd88537def476913.eot";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/iconfont/MaterialIcons-Regular.eot
// module id = 517
// module chunks = 0